import { Box, Tooltip, Group, Center, useMantineTheme, Button } from '@mantine/core';

import { IconPencil, IconSparkles } from '@tabler/icons-react';

import { AlertCircle } from '../../icons';

interface Props {
  onGenerateContent?: () => void
  onClick: () => void
  alertText?: string
}
const ResponseEditorPlaceholder: React.FC<Props> = (props: Props) => {
  const { onClick, onGenerateContent, alertText } = props;
  const { other: colorVars } = useMantineTheme();
  const alertIcon = (
    <Tooltip
      events={{ hover: true, touch: true, focus: false }}
      label={alertText}
      position='top-start'
      arrowOffset={8}
      withArrow
      multiline
    >
      <Center>
        <AlertCircle />
      </Center>
    </Tooltip>
  );

  const shouldShowAlert = alertText !== undefined;

  return (
    <Box
      onClick={onClick}
      p={'12px 16px'}
      style={{ borderRadius: '4px' }}
    >
      <Group align='center' gap={4}>
        {shouldShowAlert && alertIcon}
        <Button
          leftSection={<IconPencil />}
          styles={{
            section: {
              margin: 4
            }
          }}
          variant='subtle'
          color={colorVars.secondaryTextColor}
        >
          Write Content
        </Button>
        <Button
          variant='subtle'
          leftSection={<IconSparkles />}
          styles={{
            section: {
              margin: 4
            }
          }}
          onClick={(event) => {
            if (onGenerateContent !== undefined) {
              onGenerateContent();
            }
            event.stopPropagation();
          }}
        >
          Generate with AI
        </Button>
      </Group>
    </Box >);
};

export default ResponseEditorPlaceholder;
